'use client'

import dynamic from 'next/dynamic'
import React from 'react'

import '@/components/Form/Atoms/InputBase/InputBase.scss'
import { Props } from '@/components/Form/Organisms/CheckListProductForm/CheckListProductFormLogic'

const CheckListProductFormLogic = dynamic(
  () => import('@/components/Form/Organisms/CheckListProductForm/CheckListProductFormLogic'),
  {
    ssr: true,
  }
)

export default function CheckListProductForm({ afterSubmit, products, selectedProductIds }: Props) {
  return (
    <>
      <CheckListProductFormLogic
        afterSubmit={afterSubmit}
        products={products}
        selectedProductIds={selectedProductIds}
      />
    </>
  )
}
